export const CLOSE_EVENT: string = 'closeEvent';
export const ADD_TO_CART_EVENT: string = 'addToCartEvent';
export const LOADING: string = 'loading';
export const STORE_LOADED_EVENT = 'store.loaded';
export const STORE_RESIZE_EVENT = 'store.resize';
